import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { Navigation, Pagination } from 'swiper/modules';

new Swiper('.sp-slider', {
    modules: [Navigation, Pagination],
    loop: false,
    autoHeight: false,
    spaceBetween:32,
    slidesPerView: 1,
    pagination: {
        el: '.sp-pagination',
        clickable: true,
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
        },
        991: {
            slidesPerView: 3,
        },
    },
});